<template>
  <div v-loading="loadingFlag" class="vg_wrapper">
    <el-card>
      <editHeader
        ref="editHeader"
        :btn="btn"
        :isShow="isShow"
        :strForm="optnForm"
        @closeEdit="closeEdit"
        @openEdit="openEdit"
        @submit="submit('optnForm')"
      />
      <el-form
        ref="optnForm"
        :disabled="isShow"
        :model="optnForm"
        :rules="rules"
        class="vg_pt_16 vd_mtb vg_mt_16"
        label-width="120px"
        size="mini"
      >
        <el-row>
          <el-col :md="8">
            <el-form-item label="数据名称" prop="perm_name">
              <el-input v-model="optnForm.perm_name" disabled placeholder="数据名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="vd_button">
          <el-button plain size="small" type="primary" @click="addRow()">添加</el-button>
          <el-button plain size="small" type="danger" @click="delTeam()">删除</el-button>
        </div>
        <el-table ref="cntt" :data="optnForm.optn_cntt_list" border class="vg_mt_16" @selection-change="handleSelectionChange">
          <el-table-column align="center" type="selection" width="48"></el-table-column>
          <el-table-column align="center" label="序号" width="48">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column :label="optnForm.param1">
            <template slot-scope="scope">
              <el-form-item :prop="'optn_cntt_list.' + scope.$index + '.param1'" :rules="[{ required: true }]" label-width="0">
                <el-select v-if="Number($route.query.perm_id) === 10017" v-model="scope.row.param1" filterable placeholder="请选择">
                  <el-option v-for="item in postList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-input
                  v-else
                  v-model="optnForm.optn_cntt_list[scope.$index].param1"
                  :maxlength="maxlength1"
                  show-word-limit
                  @change="changeInput(scope)"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column v-if="optnForm.param2" :label="optnForm.param2">
            <template slot-scope="scope">
              <el-form-item :rules="[{ required: true }]" label-width="0">
                <div v-if="Number($route.query.perm_id) === 10017" style="max-height: 200px; overflow-y: auto">
                  <SimpleDynamicForm
                    :key="'param2' + scope.$index"
                    :ref="'SimpleDynamicForm' + scope.row.k"
                    :isShow="isShow"
                    :md="24"
                    @blurChange="val => (scope.row.param2 = val)"
                  ></SimpleDynamicForm>
                </div>
                <el-input
                  v-else
                  v-model="optnForm.optn_cntt_list[scope.$index].param2"
                  :maxlength="maxlength2"
                  show-word-limit
                  @change="param2Change(scope.row.param2, scope.$index)"
                  @input="val => param2Input(scope.row, val)"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column v-if="optnForm.param3" :label="optnForm.param3">
            <template slot-scope="scope">
              <el-form-item :rules="[{ required: true }]" label-width="0">
                <el-input v-model="optnForm.optn_cntt_list[scope.$index].param3" :maxlength="maxlength3" show-word-limit></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column v-if="optnForm.param4" :label="optnForm.param4">
            <template slot-scope="scope">
              <el-form-item :rules="[{ required: true }]" label-width="0">
                <el-input v-model="optnForm.optn_cntt_list[scope.$index].param4" :maxlength="maxlength4" show-word-limit></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column v-if="optnForm.param5" :label="optnForm.param5">
            <template slot-scope="scope">
              <el-form-item :rules="[{ required: true }]" label-width="0">
                <el-input v-model="optnForm.optn_cntt_list[scope.$index].param5" :maxlength="maxlength5" show-word-limit></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { get, post } from '@api/request';
import { optnAPI } from '@api/modules/optn';
import editHeader from '@/views/component/editHeader';
import SimpleDynamicForm from '@/components/SimpleDynamicForm.vue';
import { getArrayIds2 } from '@assets/js/arrayUtils';
import { keepEng } from '@assets/js/regExUtil';
import { getDataCenterByPermId } from '@api/public';

export default {
  name: 'OptnEdit',
  components: {
    SimpleDynamicForm,
    editHeader
  },
  data() {
    return {
      optnForm: {
        optn_id: '',
        perm_id: '',
        perm_name: '',
        param1: '',
        param2: null,
        param3: null,
        param4: null,
        param5: null,
        optn_cntt_list: []
      },
      rules: {
        perm_name: [{ required: true, trigger: 'blur', message: ' ' }]
      },
      key: 0,
      optn_cntt_copy: [],
      selectionsList: [],
      isShow: true,
      btn: {},
      copyForm: [],
      loadingFlag: true,
      postList: [],
      maxlength1: 30,
      maxlength2: 30,
      maxlength3: 30,
      maxlength4: 30,
      maxlength5: 30
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.$refs.editHeader.stateFlag = false;
  },
  methods: {
    keepEng,
    async initData() {
      const permId = this.$route.query.perm_id;
      if (permId) {
        //配置字段
        switch (permId) {
          case '10017':
            this.postList = await getDataCenterByPermId({ id: 10001, type: 'select' });
            break;
          case '10018':
            this.maxlength1 = 10;
            this.maxlength2 = 1;
            break;
          case '10003':
            this.maxlength2 = 1;
            break;
        }
        this.loadingFlag = true;
        this.getOptnInfo();
      }
    },
    //启用编辑
    openEdit() {
      this.isShow = false;
    },
    //撤销编辑
    closeEdit() {
      this.$confirm('是否撤销编辑?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      })
        .then(() => {
          this.isShow = true;
          this.initData();
          this.$message({
            type: 'info',
            message: '已撤销编辑!'
          });
        })
        .catch(() => {});
    },
    //获取表单信息
    getOptnInfo() {
      get(optnAPI.getOptnByPermId, { perm_id: this.$route.query.perm_id })
        .then(res => {
          if (res.data.code === 0) {
            this.optnForm = res.data.data.form;
            this.btn = res.data.data.btn;
            this.optnForm.optn_cntt_list.forEach(item => {
              item.k = this.key;
              this.key++;
            });
            this.optn_cntt_copy = this.optnForm.optn_cntt_list;
            this.copyForm = Object.assign(this.copyForm, this.optnForm.optn_cntt_list);
            setTimeout(() => {
              setTimeout(() => {
                this.updateData();
              }, 1000);
              this.loadingFlag = false;
            }, 500);
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    //添加
    addRow() {
      let item = {
        param1: '',
        destroy_flag: 0,
        k: this.key
      };
      this.key = this.key + 1;
      this.optnForm.optn_cntt_list.push(item);
      this.selectionsList = [];
    },
    // 判断是否重复
    changeInput(val) {
      let arr = this.optnForm.optn_cntt_list.filter(item => {
        if (item.param1 === val.row.param1) {
          return item;
        }
      });
      if (arr.length >= 2) {
        this.$message.warning('数据重复，请重新填写');
        this.optnForm.optn_cntt_list[val.$index].param1 = null;
        return;
      }
    },
    //多选
    handleSelectionChange(selection) {
      this.selectionsList = [];
      this.selectionsList = selection;
    },
    //多选删除
    delTeam() {
      if (this.selectionsList.length > 0) {
        for (let i = 0; i < this.selectionsList.length; i++) {
          this.optnForm.optn_cntt_list.forEach(item => {
            if (item.k === this.selectionsList[i].k) {
              let currentIndex = this.optnForm.optn_cntt_list.indexOf(item);
              this.optnForm.optn_cntt_list.splice(currentIndex, 1);
            }
          });
        }
      } else {
        this.$message({
          type: 'warning',
          message: '至少选择一条数据'
        });
      }
    },
    //提交表单
    submit(formName) {
      let flag = this.optnForm.optn_cntt_list.some(item => {
        return item.param1 == '';
      });
      if (flag) {
        let name = '';
        return this.$message.error(this.optnForm.perm_name + '名称不可为空');
      }
      this.$confirm('确定提交？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.saveInfo();
            } else {
              console.log('error submit!');
              return false;
            }
          });
        })
        .catch(() => {});
    },
    // 保存
    saveInfo() {
      this.optnForm.optn_id = this.$route.query.form_id;
      let optnForm = {};
      let optnFi = [];
      optnForm = Object.assign(optnForm, this.optnForm);
      optnFi = Object.assign(optnFi, this.optn_cntt_copy);
      for (let i = this.copyForm.length - 1; i >= 0; i--) {
        if (optnFi.indexOf(this.copyForm[i]) !== -1) {
          this.copyForm.splice(i, 1);
        }
      }
      for (let i = this.copyForm.length - 1; i >= 0; i--) {
        this.copyForm[i].destroy_flag = 1;
      }
      optnFi = optnFi.concat(this.copyForm);
      optnForm.optn_cntt_list = optnFi;
      if (Number(this.$route.query.perm_id) === 10017) {
        optnForm.optn_cntt_list.forEach((item, index) => {
          let ref2 = this.$refs['SimpleDynamicForm' + item.k];
          item.param2 = getArrayIds2(ref2?.dynamicValidateForm.domains || [], 'value', true, '/*/');
        });
      }
      post(optnAPI.editContent, optnForm)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              type: 'success',
              message: '保存成功'
            });
            this.initData();
            this.isShow = true;
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    updateData() {
      if (Number(this.$route.query.perm_id) === 10017) {
        this.optnForm.optn_cntt_list.forEach(item => {
          let ref1 = this.$refs['SimpleDynamicForm' + item.k];
          if (ref1) {
            ref1.dynamicValidateForm.domains = Array.from(item.param2?.split('/*/') || [], x => {
              return { value: x };
            });
          }
        });
      }
    },
    param2Change(val, index) {
      switch (this.$route.query.perm_id) {
        case '10018':
          if (this.optnForm.optn_cntt_list.filter(item => item.param2 === val).length > 1) {
            this.optnForm.optn_cntt_list[index].param2 = '';
            return this.$message.error('首字母代码不可重复');
          }
          break;
      }
    },
    param2Input(row, val) {
      switch (this.$route.query.perm_id) {
        case '10018':
          row.param2 = keepEng(val);
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vd_button {
  margin-top: 32px;
  border-top: 1px dashed $color-secondary-text;
  padding-top: 16px;
}

.vd_mtb {
  border-top: #c0c4cc solid 1px;
}
</style>
